import React from 'react';

const NextDocumentLoading: React.FC = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 backdrop-blur-md">
            <div className="flex flex-col items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                <p className="mt-4 text-lg text-gray-700">Loading next document</p>
            </div>
        </div>
    );
};

export default NextDocumentLoading;
